import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Controller, Scene } from "react-scrollmagic";
import { useWindowSize } from "react-use";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./desktop.css";
import Slider from "react-slick";
import img1 from "../../../images/firstComp/images/img1.webp";
import img2 from "../../../images/firstComp/images/img2.webp";
import img3 from "../../../images/firstComp/images/img3.webp";
import img4 from "../../../images/firstComp/images/img4.webp";
import img5 from "../../../images/firstComp/images/img5.webp";
import img6 from "../../../images/firstComp/images/img6.webp";
import img7 from "../../../images/firstComp/images/img7.webp";
import img8 from "../../../images/firstComp/images/img8.webp";
import video from "../../../videos/video_2.mp4";
import HorizontalScroll from "../../../horizontal-scroll";
import styled, { createGlobalStyle } from "styled-components";

export default function FirstComp() {
  return (
    <>
      <div className="firstComp desktop">
        <div className="desktop-section-1">
          <div className="desktop-firstComp-header">
            <div>X</div>
            <div>MAS</div>
            <div>story</div>
          </div>
        </div>
        <div className="desktop-firstComp-text scroll-text">
          <p>
            <b className="colored-bold">This Christmas, </b> the love you
            <b className="colored-bold"> give others</b> starts with the one you give <b>yourself.</b>
          </p>
        </div>
      </div>
    </>
  );
}
